var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_14409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 8.38243L11 10.3344M7.33333 12.6678C5.88962 11.2386 4.44517 9.81013 3 8.38243C2.6702 8.0615 2.41043 7.67577 2.23703 7.24952C2.06363 6.82327 1.98037 6.36573 1.99249 5.90572C2.00461 5.44571 2.11184 4.99319 2.30744 4.57665C2.50303 4.16012 2.78275 3.7886 3.12899 3.48548C3.47522 3.18236 3.88047 2.95422 4.3192 2.81542C4.75794 2.67661 5.22067 2.63015 5.67824 2.67896C6.13582 2.72777 6.57833 2.8708 6.97791 3.09903C7.3775 3.32727 7.7255 3.63576 8 4.00509C8.27569 3.63844 8.62409 3.33264 9.0234 3.10683C9.42271 2.88102 9.86433 2.74006 10.3206 2.69277C10.7769 2.64549 11.2381 2.69289 11.6752 2.83202C12.1123 2.97115 12.516 3.19901 12.861 3.50134C13.206 3.80366 13.4849 4.17395 13.6803 4.58902C13.8756 5.00409 13.9832 5.45502 13.9962 5.91357C14.0092 6.37212 13.9275 6.82842 13.7561 7.25393C13.5847 7.67943 13.3273 8.06498 13 8.38643",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.6654L11.3333 13.9987L14 11.332",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_14409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon07);
export default __webpack_public_path__ + "static/media/dashboard-icon-07.24f92c594b32d77b2217e95344498c3c.svg";
export { ForwardRef as ReactComponent };